<template>
  <v-container>
    <base-section-heading title="contacts.title"> </base-section-heading>
    <Section title="contacts.subtitle" text="contacts.text"></Section>

    <v-card class="mt-3 mb-3" elevation="2">
      <v-card-text>
        <vue-recaptcha
          ref="invisibleRecaptcha"
          @verify="onVerify"
          @expired="onExpired"
          size="invisible"
          :sitekey="sitekey"
        >
        </vue-recaptcha>
      </v-card-text>
    </v-card>

    <v-card class="mt-3">
      <v-card-text>
        {{ $t(contacts.text2) }}
        <v-row>
          <v-col v-for="contact in contacts.contactInfo" :key="contact.key">
            <v-card>
              <v-card-title>
                {{ $t(contact.title) }}
              </v-card-title>
              <v-card-subtitle>
                {{ $t(contact.subtitle) }}
              </v-card-subtitle>
              <v-card-text v-html="$t(contact.text)"> </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Section from "@/components/docs/Section";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: {
    Section,
    VueRecaptcha,
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_CAPTCHA_KEY,
      contacts: {
        subtitle: "contacts.subtitle",
        text: "contacts.text",
        text2: "contacts.text-2",
        contactInfo: [
          {
            key: 1,
            title: "contacts.contactInfo.contact-1.title",
            subtitle: "contacts.contactInfo.contact-1.subtitle",
            text: "contacts.contactInfo.contact-1.text",
          },
          {
            key: 2,
            title: "contacts.contactInfo.contact-2.title",
            subtitle: "contacts.contactInfo.contact-2.subtitle",
            text: "contacts.contactInfo.contact-2.text",
          },
        ],
      },
    };
  },
  methods: {
    onVerify(response) {
      console.log("reCAPTCHA verificato:", response);
      this.$refs.invisibleRecaptcha.reset();
    },
    onExpired() {
      this.$refs.invisibleRecaptcha.reset();
    },
  },
};
</script>

<style lang="scss">
.grecaptcha-badge { 
  z-index: 1;
}
</style>